import { useState, useCallback } from "react";
import preloadImage from "../../../../utils/preloadImage";
import * as imageUtils from "../../../../utils/statsImages";
import { TPreloadWidgetImage, TWidgetImagesPreloadMap } from "./types";
import { INITIAL_STATE } from "./constants";

const useWidgetImagesPreload = (): {
  preloadWidgetImage: TPreloadWidgetImage;
  reset: () => void;
} => {
  const [widgetImagesPreloadMap, setWidgetImagesPreloadMap] =
    useState<TWidgetImagesPreloadMap>(INITIAL_STATE);

  const preloadWidgetImage: TPreloadWidgetImage = useCallback(
    ({ type, username }) => {
      const hasPreloaded = widgetImagesPreloadMap[type];
      if (hasPreloaded) {
        // make sure the image is preloaded once only
        return;
      }
      let urls: string[] = [];
      switch (type) {
        case "VERIFIED_LANGUAGES":
          urls.push(
            ...Object.values(
              imageUtils.getLanguageVerificationImageUrl(username)
            )
          );
          break;
        case "DEV_COMMUNITY":
          urls.push(imageUtils.getDevToImageUrl(username));
          break;
        case "KAGGLE":
          urls.push(imageUtils.getKaggleImageUrl(username));
          break;
      }
      urls.forEach(preloadImage);
      setWidgetImagesPreloadMap((map) => ({
        ...map,
        [type]: true,
      }));
    },
    [widgetImagesPreloadMap]
  );

  const reset = useCallback(() => {
    setWidgetImagesPreloadMap(INITIAL_STATE);
  }, []);

  return {
    preloadWidgetImage,
    reset,
  };
};

export default useWidgetImagesPreload;
